import React, { useEffect, useState } from 'react';
import './Banner1.css';
import { DotLottieReact } from '@lottiefiles/dotlottie-react'
const Banner1 = () => {
    const words = ["Building", "Growing", "Scaling"];
    const [text, setText] = useState('');
    const [isDeleting, setIsDeleting] = useState(false);
    const [loopNum, setLoopNum] = useState(0);
    const [typingSpeed, setTypingSpeed] = useState(150);

    useEffect(() => {
        const handleTyping = () => {
            const i = loopNum % words.length;
            const fullText = words[i];

            setText(
                isDeleting
                    ? fullText.substring(0, text.length - 1)
                    : fullText.substring(0, text.length + 1)
            );

            setTypingSpeed(isDeleting ? 75 : 150);

            if (!isDeleting && text === fullText) {
                setTimeout(() => setIsDeleting(true), 1000);
            } else if (isDeleting && text === '') {
                setIsDeleting(false);
                setLoopNum(loopNum + 1);
            }
        };

        const timer = setTimeout(handleTyping, typingSpeed);

        return () => clearTimeout(timer);
    }, [text, isDeleting]);

    return (
        <div className="containerx">

            <div className="animation">
                <DotLottieReact className='anim'
                    src="https://lottie.host/0f07e638-6f13-40c8-97a6-ed0969c0d788/NVgbWzQG0j.lottie"
                    background="transparent"
                    speed="0.7"
                    style={{ width: '300px', height: '300px' }}
                    autoplay
                />
            </div>
            <div className="text">
                <h4>SMART DIGITAL SOLUTIONS</h4>
                <h1>
                    Empowering Brands <br />to <span id="typewriter">{text}</span> the <br />Future.
                </h1>
                <p>
                    We deliver cutting-edge IT services that accelerate growth, enhance productivity, and future-proof your business.
                    From concept to code, we turn your digital vision into scalable reality.
                </p>
                <div className="features">
                    <p>💡 Custom-built tech strategies</p>
                    <p>🚀 Agile delivery with real impact</p>
                    <p>🔐 Enterprise-grade security and support</p>
                </div>
                <button className="contact-btn">GET A FREE CONSULTATION</button>
            </div>


        </div>
    );
};

export default Banner1;
